import { useState, useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import './App.css'
import Navigation from './components/Navigation'
import Footer from './components/Footer'

// Page Components
import Home from './pages/Home'
import About from './pages/About'
import Services from './pages/Services'
import Solutions from './pages/Solutions'
import CaseStudies from './pages/CaseStudies'
import Blog from './pages/Blog'
import Contact from './pages/Contact'

// Blog Post Components
import AIAgentsFuture from './pages/blog/ai-agents-future'
import ImplementingAILegacySystems from './pages/blog/implementing-ai-legacy-systems'
import ROIMetricsAIProjects from './pages/blog/roi-metrics-ai-projects'
import EthicalAIDevelopment from './pages/blog/ethical-ai-development'
import CustomAIVsOffShelf from './pages/blog/custom-ai-vs-off-shelf'
import MLModelsSmallBusiness from './pages/blog/ml-models-small-business'
import DataPrivacyAISystems from './pages/blog/data-privacy-ai-systems'
import ConversationalAICustomerService from './pages/blog/conversational-ai-customer-service'
import PredictiveAnalyticsAI from './pages/blog/predictive-analytics-ai'
import PrivacyPolicy from './pages/PrivacyPolicy'
import TermsOfService from './pages/TermsOfService'

function AppContent() {
  const location = useLocation()
  const isHomePage = location.pathname === '/'

  return (
    <div className="min-h-screen bg-white">
      {/* Only show regular navigation for non-home pages */}
      {!isHomePage && <Navigation />}
      
      {/* Conditional padding based on page */}
      <main className={!isHomePage ? "pt-20" : ""}> {/* Add padding for fixed navigation on non-home pages */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          
          {/* Blog Post Routes */}
          <Route path="/blog/ai-agents-future" element={<AIAgentsFuture />} />
          <Route path="/blog/implementing-ai-legacy-systems" element={<ImplementingAILegacySystems />} />
          <Route path="/blog/roi-metrics-ai-projects" element={<ROIMetricsAIProjects />} />
          <Route path="/blog/ethical-ai-development" element={<EthicalAIDevelopment />} />
          <Route path="/blog/custom-ai-vs-off-shelf" element={<CustomAIVsOffShelf />} />
          <Route path="/blog/ml-models-small-business" element={<MLModelsSmallBusiness />} />
          <Route path="/blog/data-privacy-ai-systems" element={<DataPrivacyAISystems />} />
          <Route path="/blog/conversational-ai-customer-service" element={<ConversationalAICustomerService />} />
          <Route path="/blog/predictive-analytics-ai" element={<PredictiveAnalyticsAI />} />
        </Routes>
      </main>
      <Footer />
    </div>
  )
}

function App() {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setIsLoading(false)
    }, 500)

    return () => clearTimeout(timer)
  }, [])

  if (isLoading) {
    return (
      <div className="fixed inset-0 bg-black flex items-center justify-center z-50">
        <div className="text-center">
          <div className="text-white text-xl mb-4">oneAI</div>
          <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto"></div>
        </div>
      </div>
    )
  }

  return (
    <Router>
      <AppContent />
    </Router>
  )
}

export default App
